import DraftConvert from 'draft-convert';
import Draft from 'draft-js';
import { AUDIO, TEXT } from '../enum/FlashcardPageItemTypes';
import { GRADIENT_DIRECTION } from '../enum/GradientDirections';

class FlashcardPageItemClass {
    constructor(config = {}){
        this.pageItemId = config.pageItemId || new Date().valueOf();
        this.itemSequence =  config.itemSequence || 0;
        this.itemType = config.itemType;
        this.itemContent = (config.itemContent)? JSON.parse(config.itemContent) : null;
        this.isNew = config.isNew || false;
        this.itemMediaResource = config.itemMediaResource || "";
        this.consumableMediaResourceUrl = config.consumableMediaResourceUrl || "";
    }
    
    getItemContent(){
        return this.itemContent || {};
    }

    getBackgroundOpacity(){
        if(this.itemContent){
            const opacity =  parseInt(this.itemContent.backgroundOpacity || 0);
            return isNaN(opacity) ? 0 : opacity;
        }
        return 0;
    }

    getBackgroundGradientDirection(){
        return (this.itemContent && this.itemContent.backgroundGradientDirection)
            || GRADIENT_DIRECTION.NONE;
    }
    
    getImageUrl(){
        return this.consumableMediaResourceUrl|| "";
    }

    isVertical(){
        return !!this.getItemContent().isVertical;
    }

    getVideoUrl(){
        return this.consumableMediaResourceUrl|| "";
    }


    getAudioUrl(){
        return this.consumableMediaResourceUrl|| "";
    }

    getSerializedContent(){
        return JSON.stringify(this.itemContent);
    }

    isAudio(){
        return this.itemType === AUDIO;
    }

    isText(){
        return this.itemType === TEXT;
    }

    getHtmlContent(){
        const itemContent = this.getItemContent();
        const getHtmlFromDraftjsContent = item => {
            try {
                if (typeof item === "object" && item !== null) {
                    return DraftConvert.convertToHTML(Draft.convertFromRaw(item));
                }
                return "";
            } catch (e) {
                return ""
            }
        }
        return itemContent.htmlContent ? itemContent.htmlContent : getHtmlFromDraftjsContent(itemContent);
    }

    getAudioDuration(){
        return this.getItemContent().duration || 0;
    }
}

const FlashcardPageItem = config => new FlashcardPageItemClass(config)
export default FlashcardPageItem